// extracted by mini-css-extract-plugin
export default {"icon-description":"u7Oj5G","icon-description__icon":"VzRtMh","icon-description__description":"KF8504"};